<template>
  <div class="web-container">
    <menu-bar target="web"></menu-bar>
    <splitpanes class="default-theme" vertical style="height: calc(100vh - 45px)">
      <pane>
        <splitpanes horizontal>
          <pane>
            <div class="editor-container">
              <div :class="`editor-container__title editor-container__title--${$store.state.theme}`">HTML5</div>
              <div class="editor-container__editor">
                <monaco-editor-2 editorId="html" lang="html"></monaco-editor-2>
              </div>
            </div>
          </pane>
          <pane>
            <div class="editor-container">
              <div :class="`editor-container__title editor-container__title--${$store.state.theme}`">CSS3</div>
              <div class="editor-container__editor">
                <monaco-editor-2 editorId="css" lang="css"></monaco-editor-2>
              </div>
            </div>
          </pane>
          <pane>
            <div class="editor-container">
              <div :class="`editor-container__title editor-container__title--${$store.state.theme}`">Javascript</div>
              <div class="editor-container__editor">
                <monaco-editor-2
                  editorId="javascript"
                  lang="jsv"
                ></monaco-editor-2>
              </div>
            </div>
          </pane>
        </splitpanes>
      </pane>
      <pane>
        <web-output></web-output>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import MonacoEditor2 from "./editor/MonacoEditor2.vue";
import WebOutput from "./editor/WebOutput.vue";
import MenuBar from './editor/MenuBar.vue';
import "splitpanes/dist/splitpanes.css";

export default {
  name: "Web",
  components: {
    Splitpanes,
    Pane,
    MonacoEditor2,
    WebOutput,
    MenuBar
  },
  beforeCreate() {
    this.$store.commit('changeLanguage', 'html');
    this.$store.dispatch('loadDataFromServer');
  }
};
</script>

<style scoped>
.web-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
}

.editor-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.editor-container__title {
  height: 24px;
  font-size: 10px;
  padding-left: 8px;
  font-weight: bold;
}

.editor-container__title--vs-dark {
  background: rgb(30,30,30);
  color: rgb(255, 255, 255);
}

.editor-container__title--vs {
  background: rgb(255,255,255);
  color: rgb(51,51,51);
}

.editor-container__title--hc-black {
  background: rgb(0,0,0);
  color: rgb(255,255,255);
}

.editor-container__editor {
  height: calc(100% - 24px);
}

</style>

<style>
.splitpanes--vertical > .splitpanes__splitter {
  min-width: 3px;
  background: linear-gradient(90deg, gray, black);
}

.splitpanes--horizontal > .splitpanes__splitter {
  min-height: 6px;
  background: linear-gradient(0deg, gray, black);
}
</style>
